import { computed } from "vue";
import { useRoute } from "vue-router";
import { supportedLocales } from "@/locales/localization";

export function useRouteHelpers() {
    const route = useRoute();

    const isHomePage = computed(() => {
        const path = route.path.replace(/\/$/, "");
        const isHome = path === "" || supportedLocales.some((loc) => path === `/${loc}`);

        return isHome;
    });

    const isYachtsOrSearchPage = computed(() => {
        const path = route.path;

        const isYachtsOrSearch = supportedLocales.some((loc) =>
            path.startsWith(`/${loc}/yachts/`) || path === `/${loc}/search`
        );

        return isYachtsOrSearch;
    });

    const isAboutPage = computed(() => {
        const path = route.path;


        const cleanedPath = supportedLocales.some((loc) => path.startsWith(`/${loc}/`))
            ? path.replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, "/")
            : path;

        const isAbout = cleanedPath.replace(/\/$/, '') === '/about';

        return isAbout;
    });

    const isSavedOfferPage = computed(() => {
        const path = route.path;

        // Remove locale prefix if present
        const cleanedPath = supportedLocales.some((loc) => path.startsWith(`/${loc}/`))
            ? path.replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, "/")
            : path;

        // Match /:tripUuid/offers/:yachtUuid
        const regex = /^\/[^/]+\/offers\/[^/]+$/;

        return regex.test(cleanedPath);
    });
    
    const isYachtsPage = computed(() => {
        const path = route.path;
        
        const cleanedPath = supportedLocales.some((loc) => path.startsWith(`/${loc}/`))
            ? path.replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, "/") 
            : path;

        const isYachts = cleanedPath.startsWith('/yachts') && !cleanedPath.startsWith('/yachts/compare');

        return isYachts;
    });

    const isRecommendationsPage = computed(() => {
        const path = route.path.replace(/\/$/, "")
        
        const cleanedPath = supportedLocales.some((loc) => path.startsWith(`/${loc}/`))
            ? path.replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, "/")
            : path;

        const isRecomm = cleanedPath.startsWith("/recommendations");
        
        return isRecomm;
    });

    const isSearchPage = computed(() => {
        const path = route.path.replace(/\/$/, ""); // Remove trailing slash

        const cleanedPath = supportedLocales.some((loc) => path.startsWith(`/${loc}/`))
            ? path.replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, "/")
            : path;

        const isSearch = cleanedPath === "/search";
        

        return isSearch;
    });

    return { isHomePage, isYachtsOrSearchPage, isAboutPage, isYachtsPage, isRecommendationsPage, isSearchPage, isSavedOfferPage };
    
}